<div class="start-grid">
  <div>
    <h1 class="title">Svensk bevakning av antibiotikaresistens</h1>
    <p class="brodtext-medium-14">
      Svensk bevakning av antibiotikaresistens (Svebar) är ett nationellt samarbete mellan de kliniska
      mikrobiologiska<br />
      laboratorierna och Folkhälsomyndigheten för snabb återkoppling av och tidig varning för antibiotikaresistens.
      Nedan <br />
      finns en översikt av dagens inskickade analysresultat för respektive laboratorium samt nämnardata.
    </p>
    <ul *ngIf="hasStandardNameUpdates" class="standard-name-update-box mb-3">
      <div class="standard-name-update-title">
        Pågående uppdatering av standardnamn i Svebar
      </div>
      <li *ngFor="let update of standardNameUpdates">
       <strong>{{ update.oldName }} </strong> uppdateras till
        <strong>{{ update.newName }}</strong>
        –
        <span [ngSwitch]="update.status">
          <span *ngSwitchCase="'FAILED'" class="fw-bold text-danger  ">Misslyckad</span>
          <span *ngSwitchCase="'PENDING'"  class="fw-bold text-dark">Pågår</span>
          <span *ngSwitchCase="'SCHEDULED'"  class="fw-bold text-dark">Schemalagd</span>
        </span>
      </li>
      <div> <p> </p></div>
      <Strong>Schemalagda uppdateringar sker på fredag från klockan 18. </Strong>
      <p><Strong>Sökning på analysresultat är inte möjlig under uppdatering. </Strong> </p>
    </ul>
    <ng-template #noUpdates>
      <p>Inga planerade standardnamnuppdateringar.</p>
    </ng-template>

    <div class="w-75">
      <div class="d-flex w-50 cards">
        <div class="kort-informativ-mindre">
          <div class="ovrig-text-12">Totalt antal prover i Svebar</div>
          <div class="brodtext-medium-14">{{ total }}</div>
        </div>
        <div class="kort-informativ-mindre">
          <div class="ovrig-text-12">Varav med negativt analysresultat</div>
          <div class="brodtext-medium-14">{{ totalNegative }} ({{ percentageNegative }})</div>
        </div>
      </div>
      <div>
        <h5>Dagens inskickade analysresultat {{ todayDate | date: "YYYY-MM-dd" }}</h5>
        <div class="today d-flex">
          <div class="me-4">
            <div class="ovrig-text-16">Totalt prover</div>
            <div class="brodtext-medium-14">{{ todayTotal }}</div>
          </div>
          <div>
            <div class="ovrig-text-16">Nya prover</div>
            <div class="brodtext-medium-14">{{ todayNew }}</div>
          </div>
        </div>
        <app-table [config]="tableConfig" [pagination]="false"></app-table>
      </div>
    </div>
  </div>

  <div>
    <div>
      <p class="title">Dokument</p>
      <a class="pdf-link" href="assets/Manual_anvandare_v1.pdf" download="Manual_anvandare_v1.pdf"
        ><i class="fas fa-download"></i> Användarmanual för användare</a
      >
    </div>
    <div style="width: 100%">
      <a class="pdf-link" href="assets/Manual_behorigheter.pdf" download="Manual_behorigheter.pdf"
        ><i class="fas fa-download"></i> Användarmanual för behörighetsadministratörer</a
      >
    </div>
    <div style="width: 100%">
      <a class="pdf-link" href="assets/Hur kan data från Svebar användas_v1.pdf" download="Hur kan data från Svebar användas_v1.pdf"
      ><i class="fas fa-download"></i> Hur kan data från Svebar användas</a
      >
    </div>
  </div>
</div>
